function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
export default (({
  className,
  fill,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  className: className
}, props, {
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.87 8.5H19V6.5H10.87C10.43 4.77 8.86 3.5 7 3.5C4.79 3.5 3 5.29 3 7.5C3 9.71 4.79 11.5 7 11.5C8.86 11.5 10.43 10.23 10.87 8.5ZM5 7.5C5 6.4 5.9 5.5 7 5.5C8.1 5.5 9 6.4 9 7.5C9 8.6 8.1 9.5 7 9.5C5.9 9.5 5 8.6 5 7.5ZM17 12.5C15.14 12.5 13.57 13.77 13.13 15.5H5V17.5H13.13C13.57 19.23 15.14 20.5 17 20.5C19.21 20.5 21 18.71 21 16.5C21 14.29 19.21 12.5 17 12.5ZM17 18.5C15.9 18.5 15 17.6 15 16.5C15 15.4 15.9 14.5 17 14.5C18.1 14.5 19 15.4 19 16.5C19 17.6 18.1 18.5 17 18.5Z",
  fill: fill || 'currentColor'
})));
//# sourceMappingURL=Options.js.map